// นำเข้า React และ hooks ที่จำเป็น
import React, { useState, useEffect, useRef } from 'react';
import './matchgame.css';

// นำเข้าไฟล์เสียงต่างๆ
import trueSound from './assets/true.wav';           // เสียงเมื่อจับคู่ถูก
import wrongSound from './assets/wrong.wav';         // เสียงเมื่อจับคู่ผิด
// นำเข้า SweetAlert2 สำหรับแสดง popup
import Swal from 'sweetalert2';
// นำเข้า Firebase สำหรับจัดการฐานข้อมูล
import { db } from '../Firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

// import countdownSound from './assets/Countdown-90s.wav'; // ยกเลิกการ import แบบ Webpack
// const countdownSound = process.env.PUBLIC_URL + "/sounds/Countdown-90s.wav"; 
const countdownSound = "/sounds/Countdown-90s.wav"; // ใช้ path ตรงไปยัง public folder

// ตรวจสอบว่าไฟล์เสียง Matchgame-Sound.wav มีอยู่จริงหรือไม่
// ตรวจสอบว่าไฟล์เสียง Matchgame-Sound.wav มีอยู่จริงหรือไม่
// ใช้ path ตรงไปยัง public folder แทนการ require
// const matchgameSound = process.env.PUBLIC_URL + "/sounds/Matchgame-Sound.wav";
const matchgameSound = "/sounds/Matchgame-Sound.wav";

// ฟังก์ชันหลักของเกมจับคู่รูปภาพ
function MatchGame({ userData, onUserUpdate, visible, onClose }) {
  // ตัวแปรสำหรับการนำทาง
  // const navigate = useNavigate();
  
  
  // ตัวแปรสำหรับจัดการเสียง
  const audioRef = useRef(null);
  const audioElementRef = useRef(null); // สำหรับเก็บ reference ของ audio element ที่สร้างใหม่
  const playTimeoutRef = useRef(null); // Ref for audio play timeout
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  
  // สร้างคู่รูปภาพสำหรับเกม (มือกับตัวเลข 0-9)
  const imagePairs = Array.from({ length: 10 }, (_, index) => ({
    pairId: index + 1,
    image1: require(`./assets/hand-${index}.png`),    // รูปมือ
    image2: require(`./assets/number-${index}.png`)   // รูปตัวเลข
  }));

  // ฟังก์ชันสร้างการ์ดสำหรับเกม
  const createCards = () => {
    let gameCards = [];
    
    // สร้างการ์ดสำหรับแต่ละคู่รูปภาพ
    imagePairs.forEach(pair => {
      // สร้างการ์ดรูปมือ
      gameCards.push({
        id: `${pair.pairId}-1`,
        pairId: pair.pairId,
        cardType: 'image1',
        imageUrl: pair.image1,
        flipped: false,    // ยังไม่ได้พลิก
        matched: false     // ยังไม่ได้จับคู่
      });
      
      // สร้างการ์ดรูปตัวเลข
      gameCards.push({
        id: `${pair.pairId}-2`,
        pairId: pair.pairId,
        cardType: 'image2',
        imageUrl: pair.image2,
        flipped: false,    // ยังไม่ได้พลิก
        matched: false     // ยังไม่ได้จับคู่
      });
    });
    
    return shuffleArray(gameCards);
  };

  // ฟังก์ชันสลับตำแหน่งการ์ดแบบสุ่ม
  const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  // State สำหรับจัดการเกม
  const [cards, setCards] = useState([]);                    // การ์ดทั้งหมดในเกม
  const [flippedCards, setFlippedCards] = useState([]);      // การ์ดที่พลิกแล้ว (สูงสุด 2 ใบ)
  const [matchedPairs, setMatchedPairs] = useState(0);       // จำนวนคู่ที่จับคู่ได้แล้ว
  const [moves, setMoves] = useState(0);                     // จำนวนครั้งที่พลิกการ์ด
  const [canFlip, setCanFlip] = useState(true);              // สามารถพลิกการ์ดได้หรือไม่
  const [gameWon, setGameWon] = useState(false);             // เกมชนะหรือไม่
  const [timeLeft, setTimeLeft] = useState(90);              // เวลาเหลือ 90 วินาที
  const [isTimerRunning, setIsTimerRunning] = useState(false); // จับเวลาอยู่หรือไม่
  const [timeUp, setTimeUp] = useState(false);               // หมดเวลาหรือไม่
  const [isTimeoutPopupShowing, setIsTimeoutPopupShowing] = useState(false); // popup หมดเวลาแสดงอยู่หรือไม่
  
  // Refs สำหรับจัดการ popup และ timer
  const timerRef = useRef(null);                    // reference สำหรับ timer
  const timeoutPopupRef = useRef(null);             // ตรวจสอบว่า timeout popup กำลังแสดงอยู่หรือไม่
  const instructionPopupRef = useRef(null);         // ตรวจสอบว่า instruction popup กำลังแสดงอยู่หรือไม่
  const gameResultPopupRef = useRef(null);          // ตรวจสอบว่า game result popup กำลังแสดงอยู่หรือไม่



  // ฟังก์ชันสำหรับเล่นเสียง MatchGame (เสียงพื้นหลังระหว่างเล่นเกม)
  const playMatchgameSound = () => {
    //console.log('🎵 Attempting to play MatchGame sound...');
    
    // ตรวจสอบว่า component ยัง visible อยู่หรือไม่
    if (!visible) {
      //console.log('🎵 Component not visible, skipping MatchGame sound');
      return;
    }
    
    // หยุดเสียงเก่าก่อน (ถ้ามี) - ใช้ setTimeout เพื่อให้หยุดเสียงก่อน
    stopMatchgameSound();
    
    // รอให้เสียงเก่าหยุดก่อน
    playTimeoutRef.current = setTimeout(() => {
      // ตรวจสอบอีกครั้งก่อนสร้าง audio
      if (!visible) {
        //console.log('🎵 Component not visible, skipping audio creation');
        return;
      }
      
      // สร้าง audio element ใหม่
      const audio = new Audio(matchgameSound);
      audio.loop = true;        // เล่นวนซ้ำ
      audio.volume = 0.7;       // ระดับเสียง 70%
      
      // เก็บ reference
      audioElementRef.current = audio;
      
      // รอให้เสียงพร้อมเล่น
      audio.addEventListener('canplaythrough', () => {
        //console.log('🎵 Audio ready to play');
        // ตรวจสอบอีกครั้งก่อนเล่นเสียง: ต้อง visible และต้องเป็น audio instance ปัจจุบันที่ยังไม่ถูก stop
        if (visible && audioElementRef.current === audio) {
          audio.play().then(() => {
            //console.log('🎵 MatchGame sound started successfully');
            setIsAudioPlaying(true);
          }).catch((error) => {
            console.error('🎵 Error playing MatchGame sound:', error);
          });
        }
      });
      
      // จัดการ error
      audio.addEventListener('error', (e) => {
        console.error('🎵 Audio error:', e);
      });
      
      // เริ่มโหลดเสียง
      audio.load();
    }, 50); // รอ 50ms ให้เสียงเก่าหยุด
  };

  // ฟังก์ชันสำหรับหยุดเสียง MatchGame
  const stopMatchgameSound = () => {
    //console.log('🎵 Stopping MatchGame sound...');
    
    // Clear pending play timeout
    if (playTimeoutRef.current) {
      clearTimeout(playTimeoutRef.current);
      playTimeoutRef.current = null;
    }
    
    // หยุด audio element ที่สร้างใหม่
    if (audioElementRef.current) {
      try {
        audioElementRef.current.pause();
        audioElementRef.current.currentTime = 0;
        // audioElementRef.current.src = ''; // Removed to prevent error
        audioElementRef.current = null;
        //console.log('🎵 MatchGame sound stopped (audioElementRef)');
      } catch (error) {
        console.error('🎵 Error stopping audioElementRef:', error);
      }
    }
    
    // หยุด audio element ที่ใช้ ref
    if (audioRef.current) {
      try {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        // audioRef.current.src = ''; // Removed to prevent MEDIA_ELEMENT_ERROR: Empty src attribute
        //console.log('🎵 MatchGame sound stopped (audioRef)');
      } catch (error) {
        console.error('🎵 Error stopping audioRef:', error);
      }
    }
    
    // หยุดเสียงทั้งหมดที่อาจเล่นอยู่ (วิธีที่ 1)
    try {
      const allAudioElements = document.querySelectorAll('audio');
      allAudioElements.forEach(audio => {
        if (audio.src && (audio.src.includes('Matchgame-Sound') || audio.src.includes('Matchgame-Sound.wav'))) {
          audio.pause();
          audio.currentTime = 0;
          // audio.src = ''; // Removed to prevent error
          //console.log('🎵 Stopped audio element:', audio.src);
        }
      });
    } catch (error) {
      console.error('🎵 Error stopping audio elements:', error);
    }
    
    // หยุดเสียงทั้งหมดที่เล่นอยู่ในหน้าเว็บ (วิธีที่ 2)
    try {
      const allAudio = document.querySelectorAll('audio, video');
      allAudio.forEach(media => {
        if (media.src && media.src.includes('Matchgame-Sound')) {
          media.pause();
          media.currentTime = 0;
          // media.src = ''; // Removed to prevent error
          //console.log('🎵 Stopped media element:', media.src);
        }
      });
    } catch (error) {
      console.error('🎵 Error stopping media elements:', error);
    }
    
    // หยุดเสียงทั้งหมดที่เล่นอยู่ในหน้าเว็บ (วิธีที่ 3 - บังคับหยุด)
    try {
      const allAudio = document.querySelectorAll('audio');
      allAudio.forEach(audio => {
        if (audio.src && audio.src.includes('Matchgame-Sound')) {
          audio.pause();
          audio.currentTime = 0;
          // audio.src = ''; // Removed to prevent error
          //console.log('🎵 Force stopped audio element:', audio.src);
        }
      });
    } catch (error) {
      console.error('🎵 Error force stopping audio elements:', error);
    }
    
    // อัปเดต state
    setIsAudioPlaying(false);
    //console.log('🎵 All MatchGame sounds stopped');
  };

  // ฟังก์ชันสำหรับเล่นเสียง Countdown-90s (เสียงนับถอยหลัง 90 วินาที)
  const playCountdownSound = () => {
    //console.log('⏰ Playing Countdown-90s sound...');
    
    // ตรวจสอบว่า component ยัง visible อยู่หรือไม่
    if (!visible) {
      //console.log('⏰ Component not visible, skipping countdown sound');
      return;
    }

    // หยุดเสียงเก่าก่อนเสมอเพื่อป้องกันเสียงซ้อน
    stopCountdownSound();
    
    
    const countdownAudio = new Audio(countdownSound);
    countdownAudio.volume = 0.8;      // ระดับเสียง 80%
    countdownAudio.loop = false;      // ไม่เล่นวนซ้ำ
    
    // เก็บ reference ของ countdown audio
    window.countdownAudioRef = countdownAudio;
    
    // รอให้เสียงพร้อมเล่น
    countdownAudio.addEventListener('canplaythrough', () => {
      //console.log('⏰ Countdown audio ready to play');
      // ตรวจสอบอีกครั้งก่อนเล่นเสียง: ต้อง visible และต้องเป็น audio instance ปัจจุบันที่ยังไม่ถูก stop
      if (visible && window.countdownAudioRef === countdownAudio) {
        countdownAudio.play().then(() => {
          //console.log('⏰ Countdown-90s sound started successfully');
        }).catch((error) => {
          console.error('⏰ Error playing Countdown sound:', error);
        });
      }
    });
    
    // จัดการ error
    countdownAudio.addEventListener('error', (e) => {
      console.error('⏰ Countdown audio error:', e);
    });
    
    // เมื่อเสียงจบ
    countdownAudio.addEventListener('ended', () => {
      //console.log('⏰ Countdown-90s sound finished');
    });
    
    // เริ่มโหลดเสียง
    countdownAudio.load();
  };

  // ฟังก์ชันสำหรับหยุดเสียง Countdown-90s
  const stopCountdownSound = () => {
    //console.log('⏰ Stopping Countdown-90s sound...');
    
    // หยุดเสียงจาก reference
    if (window.countdownAudioRef) {
      try {
        window.countdownAudioRef.pause();
        window.countdownAudioRef.currentTime = 0;
        // window.countdownAudioRef.src = ''; // Removed to prevent error
        window.countdownAudioRef = null;
        //console.log('⏰ Countdown-90s sound stopped');
      } catch (error) {
        console.error('⏰ Error stopping Countdown sound:', error);
      }
    }
    
    // หยุดเสียง Countdown ทั้งหมดที่อาจเล่นอยู่
    try {
      const allAudioElements = document.querySelectorAll('audio');
      allAudioElements.forEach(audio => {
        if (audio.src && audio.src.includes('Countdown-90s')) {
          audio.pause();
          audio.currentTime = 0;
          // audio.src = ''; // Removed to prevent error
          //console.log('⏰ Stopped Countdown audio element:', audio.src);
        }
      });
    } catch (error) {
      console.error('⏰ Error stopping Countdown audio elements:', error);
    }
  };

  // ฟังก์ชันเริ่มเกมใหม่
  const startGame = () => {
    //console.log('🎮 Starting new game...');
    
    // ตรวจสอบว่า component ยัง visible อยู่หรือไม่
    if (!visible) {
      //console.log('🎮 Component not visible, skipping game start');
      return;
    }
    
    // สร้างการ์ดใหม่และสลับตำแหน่ง
    const newCards = createCards();
    setCards(newCards);
    
    // รีเซ็ต state ทั้งหมด
    setFlippedCards([]);           // การ์ดที่พลิกแล้ว
    setMatchedPairs(0);            // จำนวนคู่ที่จับคู่ได้
    setMoves(0);                   // จำนวนครั้งที่พลิก
    setCanFlip(true);              // สามารถพลิกการ์ดได้
    setGameWon(false);             // ยังไม่ชนะ
    setTimeLeft(90);               // เวลาเหลือ 90 วินาที
    setTimeUp(false);              // ยังไม่หมดเวลา
    setIsTimerRunning(false);      // ยังไม่เริ่มจับเวลา
    
    
    // รีเซ็ต popup refs
    timeoutPopupRef.current = false;
    instructionPopupRef.current = false;
    gameResultPopupRef.current = false;
    setIsTimeoutPopupShowing(false);
  };

  // ฟังก์ชันเริ่มจับเวลา 90 วินาที
  const startTimer = async () => {
    //console.log('⏰ Starting 90-second timer...');
    
    // ตรวจสอบว่า component ยัง visible อยู่หรือไม่ก่อนเริ่ม timer
    if (!visible) {
      //console.log('⏰ Component not visible, skipping timer start');
      return;
    }
    
    setIsTimerRunning(true);
    setTimeLeft(90);
    setTimeUp(false);
    
    // ตรวจสอบอีกครั้งว่า component ยัง visible อยู่หรือไม่
    if (!visible) {
      //console.log('⏰ Component not visible, skipping timer start');
      return;
    }
    
    // เริ่มจับเวลานับถอยหลัง
    timerRef.current = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          // หมดเวลา - หยุด timer และตั้งค่า state
          clearInterval(timerRef.current);
          setIsTimerRunning(false);
          setTimeUp(true);
          setCanFlip(false);
          //console.log('⏰ Time up! Game over.');
          return 0;
        }
        return prevTime - 1;  // ลดเวลาลง 1 วินาที
      });
    }, 1000);  // ทำงานทุก 1 วินาที
  };

  // ฟังก์ชันหยุดจับเวลา
  const stopTimer = () => {
    //console.log('⏰ Stopping timer...');
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    setIsTimerRunning(false);
  };



  // useEffect สำหรับเริ่มเกมเมื่อ component โหลด
  useEffect(() => {
    // ตรวจสอบว่า component ควรแสดงหรือไม่
    if (!visible) {
      //console.log('🎮 Component not visible, skipping game initialization');
      return;
    }

    //console.log('🎮 Component visible, starting game...');
    // เริ่มเกมเมื่อ component โหลด
    startGame();

    // เสียงจะเล่นเมื่อแสดง information popup ใน didOpen callback

    // แสดง instruction ทันทีเมื่อเริ่ม run program (เฉพาะเมื่อไม่ใช่ timeout popup)
    if (!timeoutPopupRef.current && !instructionPopupRef.current) {
      instructionPopupRef.current = true;
      Swal.fire({
      title: 'เกมจับคู่',
      html: `
        <div style="text-align: center;">
          <p style="font-size: 18px; margin-bottom: 20px;"><strong>จับคู่รูปภาพที่เหมือนกันภายใน 90 วินาที</strong></p>
          <div style="background-color: #f8f9fa; padding: 15px; border-radius: 8px; margin: 15px 0;">
            <h4 style="margin: 0 0 10px 0; color: #495057;">ระบบคะแนน:</h4>
            <p style="margin: 5px 0; color: #000000;">เปิดแผ่นป้ายน้อยกว่า 20 ครั้ง รับ 50 คะแนน</p>
            <p style="margin: 5px 0; color: #000000;">เปิดแผ่นป้าย 21 - 25 ครั้ง รับ 40 คะแนน</p>
            <p style="margin: 5px 0; color: #000000;">เปิดแผ่นป้าย 26 - 30 ครั้ง รับ 30 คะแนน</p>
            <p style="margin: 5px 0; color: #000000;">เปิดแผ่นป้ายมากกว่า 30 ครั้ง รับ 10 คะแนน</p>
          </div>
          <p style="font-size: 14px; color: #6c757d; margin-top: 15px;">คลิกที่แผ่นป้ายเพื่อจับคู่รูปภาพที่เหมือนกันให้ถูกต้อง</p>
        </div>
      `,
      icon: 'info',
      confirmButtonText: 'เข้าใจแล้ว!',
      confirmButtonColor: '#007bff',
      allowOutsideClick: false, // ป้องกันการปิดโดยคลิกข้างนอก
      allowEscapeKey: false,    // ป้องกันการปิดโดยกด Esc
      showConfirmButton: true,
      showCancelButton: false,
      showCloseButton: false,
      timer: 0,
      timerProgressBar: false,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      },
      didOpen: () => {
        // เล่นเสียง Matchgame-Sound.wav เมื่อแสดง information popup
        //console.log('🎵 Information popup opened - playing Matchgame sound');
        playMatchgameSound();
      },
      willClose: () => {
        // หยุดเสียง Matchgame-Sound.wav เมื่อปิด information popup
        //console.log('🎵 Information popup will close - stopping Matchgame sound');
        stopMatchgameSound();
        
        // หยุดเสียงอีกครั้งหลังจาก 100ms เพื่อให้แน่ใจ
        setTimeout(() => {
          stopMatchgameSound();
          //console.log('🎵 Force stop Matchgame sound after 100ms');
        }, 100);
      },
      didClose: () => {
        // หยุดเสียง Matchgame-Sound.wav อีกครั้งเพื่อให้แน่ใจ
        //console.log('🎵 Information popup closed - force stopping Matchgame sound');
        stopMatchgameSound();
        
        // รีเซ็ต instruction popup ref
        instructionPopupRef.current = false;
        
        // ตรวจสอบว่า component ยัง visible อยู่หรือไม่
        if (!visible) {
          //console.log('⏰ Component not visible, skipping game start');
          return;
        }
        
        // เล่นเสียง Countdown-90s.wav หลังจากปิด information popup แล้ว
        //console.log('⏰ Information popup closed - playing Countdown-90s sound');
        // ใช้ setTimeout เพื่อให้แน่ใจว่าเสียง Matchgame หยุดเล่นแล้ว
        setTimeout(() => {
          if (visible) {
            playCountdownSound();
          }
        }, 200); // เพิ่มเวลาเป็น 200ms
        
        // เริ่มจับเวลา 90 วินาที
        setTimeout(() => {
          if (visible) {
            //console.log('⏰ Starting timer after information popup closed');
            startTimer();
          } else {
            //console.log('⏰ Component not visible, skipping timer start after popup close');
          }
        }, 500); // รอ 500ms ให้เสียง Countdown เริ่มเล่นก่อน
      }
    });
    }

  }, [visible]);

  // useEffect สำหรับปิด popup และหยุดเสียงเมื่อ component ไม่ visible
  useEffect(() => {
    if (!visible) {
      // ปิด SweetAlert popup ที่อาจเปิดอยู่ (เฉพาะ instruction popup)
      // ไม่ปิด timeout popup หรือ game result popup เพราะมันควรแสดงต่อ
      if (!timeoutPopupRef.current && !gameResultPopupRef.current) {
        Swal.close();
        instructionPopupRef.current = false;
      }
      // หยุดเสียง MatchGame และ Countdown
      stopMatchgameSound();
      stopCountdownSound();
      // หยุดจับเวลา
      stopTimer();
      //console.log('🎵 MatchGame closed - stopping sounds and timer');
    }
  }, [visible]);

  // useEffect สำหรับ cleanup เมื่อ component unmount
  useEffect(() => {
    return () => {
      // หยุดเสียงเมื่อ component unmount
      stopMatchgameSound();
      stopCountdownSound();
      // หยุดจับเวลาเมื่อ component unmount
      stopTimer();
      //console.log('🎵 Component unmounting - stopping sounds and timer');
    };
  }, []);

  // useEffect สำหรับจัดการการจับคู่การ์ด
  useEffect(() => {
    if (flippedCards.length === 2) {
      setCanFlip(false);        // หยุดการพลิกการ์ดชั่วคราว
      setMoves(moves + 1);      // เพิ่มจำนวนครั้งที่พลิก
      
      const [card1, card2] = flippedCards;
      const isMatch = card1.pairId === card2.pairId;  // ตรวจสอบว่าจับคู่ถูกหรือไม่
      
      // เล่นเสียงตามผลการจับคู่
      const sound = new Audio(isMatch ? trueSound : wrongSound);
      sound.play();

      // รอ 1 วินาทีแล้วจัดการผลลัพธ์
      setTimeout(() => {
        if (isMatch) {
          // จับคู่ถูก - ตั้งค่า matched = true
          setCards(prevCards => 
            prevCards.map(card => 
              card.id === card1.id || card.id === card2.id 
                ? { ...card, matched: true } 
                : card
            )
          );
          setMatchedPairs(prev => prev + 1);  // เพิ่มจำนวนคู่ที่จับคู่ได้
        } else {
          // จับคู่ผิด - กลับการ์ดเป็น flipped = false
          setCards(prevCards => 
            prevCards.map(card => 
              card.id === card1.id || card.id === card2.id 
                ? { ...card, flipped: false } 
                : card
            )
          );
        }
        
        setFlippedCards([]);    // รีเซ็ตการ์ดที่พลิก
        setCanFlip(true);       // อนุญาตให้พลิกการ์ดได้อีก
      }, 1000);
    }
  }, [flippedCards]);

  // useEffect สำหรับตรวจสอบการชนะเกม
  useEffect(() => {
    if (matchedPairs === imagePairs.length) {
      // หยุดจับเวลาเมื่อเกมจบ
      stopTimer();
      setTimeout(() => {
        setGameWon(true);           // ตั้งค่าเกมชนะ
        calculateAndSaveScore();    // คำนวณและบันทึกคะแนน
      }, 500);
    }
  }, [matchedPairs]);

  // useEffect สำหรับตรวจสอบหมดเวลา
  useEffect(() => {
    if (timeUp && !gameWon && !timeoutPopupRef.current) {
      //console.log('⏰ Time is up! Showing timeout message...');
      // หยุดจับเวลา
      stopTimer();
      // แสดงข้อความหมดเวลา
      showTimeoutMessage();
    }
  }, [timeUp, gameWon]);

  // ฟังก์ชันแสดงข้อความหมดเวลา
  const showTimeoutMessage = async () => {
    // ตรวจสอบว่า popup กำลังแสดงอยู่หรือไม่
    if (timeoutPopupRef.current) {
      //console.log('⏰ Timeout popup already showing, skipping...');
      return;
    }
    
    // ตั้งค่า ref ว่า timeout popup กำลังแสดง
    timeoutPopupRef.current = true;
    setIsTimeoutPopupShowing(true);
    
    // 1. หยุดเสียง Matchgame-Sound.wav และ Countdown-90s.wav
    stopMatchgameSound();
    stopCountdownSound();
    
    // 2. แสดง popup "หมดเวลา!" พร้อมผลการเล่น
    Swal.fire({
      title: 'หมดเวลา!',
      html: `
        <div style="text-align: center;">
          <p style="font-size: 18px; margin-bottom: 20px; color: #dc3545;">
            <strong>คุณใช้เวลาเกิน 90 วินาที</strong>
          </p>
          <div style="background-color: #f8d7da; padding: 15px; border-radius: 8px; margin: 15px 0; border: 1px solid #f5c6cb;">
            <h4 style="margin: 0 0 10px 0; color: #721c24;">ผลการเล่น:</h4>
            <p style="margin: 5px 0; color: #721c24;">คู่ที่จับได้: ${matchedPairs}/${imagePairs.length}</p>
            <p style="margin: 5px 0; color: #721c24;">จำนวนครั้งที่พลิก: ${moves}</p>
            <p style="margin: 5px 0; color: #721c24; font-weight: bold;">คะแนนที่ได้: 0 คะแนน</p>
          </div>
          <p style="font-size: 14px; color: #6c757d; margin-top: 15px;">ลองใหม่อีกครั้งเพื่อให้ได้คะแนน!</p>
        </div>
      `,
      icon: 'error',
      confirmButtonText: 'ตกลง',
      confirmButtonColor: '#dc3545',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      showCancelButton: false,
      showCloseButton: false,
      timer: 0,
      timerProgressBar: false,
      didOpen: () => {
        //console.log('⏰ Timeout popup opened');
      },
      willClose: () => {
        //console.log('⏰ Timeout popup will close');
        timeoutPopupRef.current = false;
        setIsTimeoutPopupShowing(false);
        
        // หยุดเสียงทั้งหมดเมื่อ popup จะปิด
        stopMatchgameSound();
        stopCountdownSound();
        //console.log('🎵 All sounds stopped in timeout willClose callback');
      },
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    }).then((result) => {
      //console.log('⏰ Timeout popup closed by user:', result);
      
      // 3. เมื่อกดปุ่ม "ตกลง": ปิดเกม
      // หยุดเสียงทั้งหมด
      stopMatchgameSound();
      stopCountdownSound();
      //console.log('🎵 All sounds stopped after timeout popup closed');
      
      // หยุดจับเวลา
      stopTimer();
      
      // ปิด modal
      if (onClose) {
        onClose();
      }
    }).catch((error) => {
      console.error('Error showing timeout popup:', error);
      // ถ้า popup มีปัญหา ให้ปิดเกมเลย
      timeoutPopupRef.current = false;
      setIsTimeoutPopupShowing(false);
      
      // หยุดเสียงทั้งหมด
      stopMatchgameSound();
      stopCountdownSound();
      //console.log('🎵 All sounds stopped after timeout popup error');
      
      // หยุดจับเวลา
      stopTimer();
      
      if (onClose) {
        onClose();
      }
    });

    // Save step5-total on Time Up
    if (userData?.username) {
      try {
        const collectionName = userData.collection || "Student-history";
        const userRef = doc(db, collectionName, userData.username);
        const docSnap = await getDoc(userRef);
        
        let currentStep5Total = 0;
        if (docSnap.exists()) {
           const data = docSnap.data();
           currentStep5Total = data['step5-total'] || 0;
        }
        
        const newStep5Total = currentStep5Total + 1;
        
        await setDoc(userRef, {
            'step5-total': newStep5Total
        }, { merge: true });
        
        console.log('Updated step5-total (Time Up):', newStep5Total);
      } catch (e) {
        console.error("Error updating time up stats:", e);
      }
    }

  };

  const calculateAndSaveScore = async () => {
    let scoreToAdd = 0;
    
    if (moves <= 20) {
      scoreToAdd = 50;
    } else if (moves <= 25) {
      scoreToAdd = 40;
    } else if (moves <= 30) {
      scoreToAdd = 30;
    } else {
      scoreToAdd = 10;
    }
    
    // หยุดเสียง MatchGame และ Countdown เมื่อเกมจบ
    stopMatchgameSound();
    stopCountdownSound();
    //console.log('🎵 Game completed - stopping sounds');

    // ตั้งค่า ref ว่า game result popup กำลังแสดง
    gameResultPopupRef.current = true;
    
    Swal.fire({
      title: 'เกมจบ!',
      html: `<p>คุณใช้การพลิก ${moves} ครั้ง</p>
             <p>คุณได้คะแนน ${scoreToAdd} คะแนน</p>`,
      icon: 'success',
      confirmButtonText: 'ตกลง',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      showCancelButton: false,
      showCloseButton: false,
      timer: 0,
      timerProgressBar: false,
      didOpen: () => {
        //console.log('🎯 Game result popup opened');
      },
      willClose: () => {
        //console.log('🎯 Game result popup will close');
        gameResultPopupRef.current = false;
        
        // หยุดเสียงทั้งหมดเมื่อ popup จะปิด
        stopMatchgameSound();
        stopCountdownSound();
        //console.log('🎵 All sounds stopped in willClose callback');
      }
    }).then((result) => {
      //console.log('🎯 Game result popup closed by user:', result);
      // รีเซ็ต ref
      gameResultPopupRef.current = false;
      
      // หยุดเสียงทั้งหมด
      stopMatchgameSound();
      stopCountdownSound();
      //console.log('🎵 All sounds stopped after game result popup closed');
      
      // หยุดจับเวลา
      stopTimer();
      
      // ปิด modal
      if (onClose) {
        onClose();
      }
    }).catch((error) => {
      console.error('Error showing game result popup:', error);
      // รีเซ็ต ref
      gameResultPopupRef.current = false;
      
      // หยุดเสียงทั้งหมด
      stopMatchgameSound();
      stopCountdownSound();
      //console.log('🎵 All sounds stopped after game result popup error');
      
      // หยุดจับเวลา
      stopTimer();
      
      // ปิด modal แม้มี error
      if (onClose) {
        onClose();
      }
    });
    
    
    if (userData?.username) {
      try {
        const collectionName = userData.collection || "Student-history";
        const userRef = doc(db, collectionName, userData.username);
        const docSnap = await getDoc(userRef);
        
        let currentScore = 0;
        let currentStep5 = 0;
        let currentStep5Total = 0;
        let currentStep5Speed = 0;

        if (docSnap.exists()) {
           const data = docSnap.data();
           currentScore = data.score || 0;
           currentStep5 = data.step5 || 0;
           currentStep5Total = data['step5-total'] || 0;
           currentStep5Speed = data['step5-speed'] || 0;
        }
        
        const newScore = currentScore + scoreToAdd;
        const newStep5 = currentStep5 + 1;
        const newStep5Total = currentStep5Total + 1;
        
        // Calculate Speed: (timeLeft / 90) * 100
        const speedScore = (timeLeft / 90) * 100;
        
        // Average speed calculation (consistent with other games)
        let newStep5Speed = speedScore;
        if (currentStep5Speed > 0) {
            newStep5Speed = (currentStep5Speed + speedScore) / 2;
        }
        
        await setDoc(userRef, {
            score: newScore,
            step5: newStep5,
            'step5-total': newStep5Total,
            'step5-speed': newStep5Speed
        }, { merge: true });
        
        console.log('Game Won Stats Updated:', {
            newScore,
            newStep5,
            newStep5Total,
            newStep5Speed
        });
        
      } catch (error) {
        console.error("Error updating user data:", error);
      }
    }
  };

  const handleCardClick = (card) => {
    if (!canFlip || card.flipped || card.matched || flippedCards.length >= 2) {
      return;
    }
    
    setCards(prevCards => 
      prevCards.map(c => 
        c.id === card.id ? { ...c, flipped: true } : c
      )
    );
    
    setFlippedCards(prev => [...prev, card]);
  };



  const getLetterForPosition = (index) => {
    const row = Math.floor(index / 5);
    const col = index % 5;
    return String.fromCharCode(65 + row * 5 + col);
  };



  // Debug: แสดงค่า visible prop
  //console.log('🎯 MatchGame component - visible prop:', visible);

  // ถ้าไม่ visible ให้ไม่แสดงอะไร
  if (!visible) {
    //console.log('🎯 MatchGame component - not visible, returning null');
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content match-game-modal">
        {/* Audio element สำหรับเสียง MatchGame */}
        {/* Audio element removed to avoid duplicate loading and errors. Audio is handled programmatically via new Audio() */}
        <div className="app">
      <div className="header">
        <h1>เกมจับคู่รูปภาพ</h1>
        <div className={`subtitle ${timeLeft <= 10 ? 'time-warning' : ''}`}>
          เวลาเหลือ: {timeLeft} วินาที
        </div>
      </div>
      
      <div className="main-container">
        <div className="game-board">
          {cards.map((card, index) => (
            <div 
              key={card.id}
              className={`card ${card.flipped || card.matched ? 'flipped' : ''} ${card.matched ? 'matched' : ''}`}
              onClick={() => handleCardClick(card)}
            >
              <div className="card-face card-front">
                {getLetterForPosition(index)}
              </div>
              <div 
                className="card-face card-back" 
                style={{ backgroundImage: `url(${card.imageUrl})` }}
              ></div>
            </div>
          ))}
        </div>
        
        <div className="game-info">
          {/* เพิ่มโลโก้ Wisdom ด้านบนของสถิติ */}

          
          <div className="stats-container">
            <div className="stats">
              <div className="stat-box">
                <div className="stat-label">จำนวนครั้งที่พลิก</div>
                <div className="stat-value">{moves}</div>
              </div>
              
              <div className="stat-box">
                <div className="stat-label">คู่ที่ถูกต้อง</div>
                <div className="stat-value">{matchedPairs}/{imagePairs.length}</div>
              </div>
              

            </div>
          </div>
        </div>
      </div>
      
      {gameWon && (
        <div className="win-message show">
          <div className="win-content">
            <h2>ยินดีด้วย!</h2>
            <p>คุณชนะใน {moves} ครั้ง</p>
          </div>
        </div>
      )}
        </div>
      </div>
    </div>
  );
}

export default MatchGame;